export { ZoomOutAlt as default } from './ZoomOutAlt';
